function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_1693",
  "data-name": "Group 1693",
  transform: "translate(0.5)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Icon_feather-alert-octagon",
  "data-name": "Icon feather-alert-octagon",
  transform: "translate(0 7.449)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_151",
  "data-name": "Path 151",
  d: "M19.569,3H42.981L59.551,19.569V42.981L42.981,59.551H19.569L3,42.981V19.569Z",
  transform: "translate(-3 -3)",
  fill: "none",
  stroke: "#707070",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_152",
  "data-name": "Path 152",
  d: "M18,12V23.31",
  transform: "translate(10.275 4.965)",
  fill: "#707070",
  stroke: "#707070",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 5
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_153",
  "data-name": "Path 153",
  d: "M18,24h0",
  transform: "translate(10.275 15.586)",
  fill: "none",
  stroke: "#707070",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 5
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_1077",
  "data-name": "Group 1077",
  transform: "translate(36)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Ellipse_33",
  "data-name": "Ellipse 33",
  fill: "#f8f8f8",
  stroke: "#707070",
  strokeWidth: 1
}, /*#__PURE__*/React.createElement("ellipse", {
  cx: 14.5,
  cy: 14,
  rx: 14.5,
  ry: 14,
  stroke: "none"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 14.5,
  cy: 14,
  rx: 14,
  ry: 13.5,
  fill: "none"
})), /*#__PURE__*/React.createElement("path", {
  id: "Path_154",
  "data-name": "Path 154",
  d: "M22.333,20.884l-3.38-3.38,3.38-3.38a1.025,1.025,0,0,0-1.449-1.449l-3.38,3.38-3.38-3.38a1.025,1.025,0,1,0-1.449,1.449l3.38,3.38-3.38,3.38a.991.991,0,0,0,0,1.449,1.018,1.018,0,0,0,1.449,0l3.38-3.38,3.38,3.38a1.03,1.03,0,0,0,1.449,0A1.018,1.018,0,0,0,22.333,20.884Z",
  transform: "translate(-2.876 -3.205)",
  fill: "#707070"
})));

function SvgOctagonWithExclamation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 65.5,
    height: 64.5,
    viewBox: "0 0 65.5 64.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOctagonWithExclamation);
export default __webpack_public_path__ + "static/media/octagonWithExclamation.8ce528bace070f991c822fbc8a76a447.svg";
export { ForwardRef as ReactComponent };